var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5958_2402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56422 3.70972C1.48757 4.72732 1.42859 6.08296 1.42859 7.14026C1.42859 8.50807 1.52732 9.8468 1.63526 11.1457C1.7489 12.5133 2.80656 13.6515 4.16523 13.8445C4.41969 13.8806 4.67602 13.9144 4.93409 13.9438",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5285 10.2894C2.89207 10.1635 1.57676 9.17104 1.42859 7.96338",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81166 6.34692C2.69447 6.0593 1.5332 5.22435 1.5332 3.9435C1.5332 2.33388 3.36706 1.42847 6.62726 1.42847C9.10942 1.42847 10.7648 1.9533 11.4135 2.91415",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3445 8.2312C18.4327 9.34912 18.5045 10.4948 18.5045 11.6617C18.5045 13.0296 18.4058 14.3683 18.2978 15.6672C18.1843 17.0348 17.1265 18.1729 15.768 18.3659C14.9645 18.4801 14.1424 18.5713 13.3059 18.5713C12.4693 18.5713 11.6472 18.4801 10.8438 18.3659C9.48516 18.1729 8.42749 17.0348 8.31385 15.6672C8.20591 14.3683 8.10718 13.0296 8.10718 11.6617C8.10718 10.6044 8.16616 9.2488 8.24281 8.2312",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5045 12.4851C18.3564 13.6928 17.0411 14.6852 15.4047 14.8111C14.7168 14.8641 14.0164 14.9024 13.3059 14.9024C12.5953 14.9024 11.8949 14.8641 11.2071 14.8111C9.57066 14.6852 8.25535 13.6928 8.10718 12.4851",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.306 10.98C16.5662 10.98 18.4001 10.0746 18.4001 8.46498C18.4001 6.85537 16.5662 5.94995 13.306 5.94995C10.0458 5.94995 8.21191 6.85537 8.21191 8.46498C8.21191 10.0746 10.0458 10.98 13.306 10.98Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5958_2402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStack);
export default __webpack_public_path__ + "static/media/coin-stack.308c07531eae13d5e1b39256ee7b7caa.svg";
export { ForwardRef as ReactComponent };